import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  ViewChild,
} from '@angular/core';
import { ToastService } from '../../services/toast.service';
import { FileUtils } from '../../utils/file.utils';
import { TranslationService } from '@services/translation.service';

@Component({
  selector: 'app-drop-zone',
  templateUrl: 'drop-zone.component.html',
  styleUrls: ['drop-zone.component.scss'],
  host: {
    '[class.state-disabled]': '!!disabled',
  },
})
export class DropZoneComponent {
  @ViewChild('inputEl', { static: true })
  inputElRef: ElementRef<HTMLInputElement>;

  @Output()
  onFileChange = new EventEmitter<File>();

  @Input()
  disabled = false;

  @Input()
  allowedFilesExt: string[] = ['*'];

  @Input()
  info: string;

  get allowedFilesExtStr() {
    return this.allowedFilesExt?.join(',') ?? '*';
  }

  constructor(
    private toastService: ToastService,
    public translationService: TranslationService
  ) {}

  @HostListener('dragover', ['$event'])
  onFileDragover(e: DragEvent) {
    e.preventDefault();
  }

  @HostListener('drop', ['$event'])
  onFileDrop(e: DragEvent) {
    e.preventDefault();
    const file = e.dataTransfer?.files?.item(0);
    this.emitFile(file);
  }

  onChange(e) {
    const file = this.inputElRef.nativeElement.files?.item(0);
    this.emitFile(file);

    this.inputElRef.nativeElement.value = null;
  }

  onBtnSearchClick(e) {
    this.inputElRef.nativeElement.click();
  }

  private emitFile(file: File) {
    if (this.validateFile(file)) {
      this.onFileChange.emit(file);
    }
  }

  private validateFile(file: File): boolean {
    return file && FileUtils.isFileExts(file, this.allowedFilesExt);
  }
}
